var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticStyle:{"width":"100px"},attrs:{"size":_vm.size,"disabled":!_vm.canSendCode},on:{"click":_vm.sendCode}},[_c('span',{domProps:{"textContent":_vm._s(_vm.sendBtnText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }